import React from 'react'
import SWTable from './SWTable'
import { Form } from 'antd'
import SGOTable from './SGOTable'
import SOFTable from './SOFTable'
import SWOPlot from './SWOPlot'
import SGOPlot from './SGOPlot'
import SOFPlot from './SOFPlot'

const SCALSettingTab = ({ tab }) => {
  const form = Form.useFormInstance()
  const fluidType = Form.useWatch(["GENERAL", "fluid"], form)
  
  const isCondensate = fluidType === 'CONDENSATE'
  const isGas = fluidType === 'GAS'

  return (
    <>
      <div className="row">
        <div className="col-6">
          <Form.List name={["SCAL", tab, "SWO"]}>
            {(fields, operation) => (
              <SWTable 
                tab={tab} 
                fields={fields} 
                operation={operation}
                isCondensate={isCondensate || isGas} 
              />
            )}
          </Form.List>
        </div>
        <div className="col-6">
          <div className="vstack gap-2">
            <SWOPlot 
              name={["SCAL", tab, "SWO"]} 
              isCondensate={isCondensate || isGas}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Form.List name={["SCAL", tab, "SGO"]}>
            {(fields, operation) => (
              <SGOTable 
                tab={tab} 
                fields={fields} 
                operation={operation}
                isCondensate={isCondensate}
                isGas={isGas}
              />
            )}
          </Form.List>
        </div>
        <div className="col-6">
          <div className="vstack gap-2">
            <SGOPlot 
              name={["SCAL", tab, "SGO"]} 
              isCondensate={isCondensate}
              isGas={isGas}
            />
          </div>
        </div>
      </div>
      {isCondensate && (
        <div className="row">
          <div className="col-6">
            <Form.List name={["SCAL", tab, "SOF"]}>
              {(fields, operation) => (
                <SOFTable 
                  tab={tab} 
                  fields={fields} 
                  operation={operation} 
                />
              )}
            </Form.List>
          </div>
          <div className="col-6">
            <div className="vstack gap-2">
              <SOFPlot name={["SCAL", tab, "SOF"]} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SCALSettingTab